import React from "react";
import useTranslation from "../../hooks/Translation";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

const Settings = () => {
  const translation = useTranslation() as any;
  const label = { inputProps: { "aria-label": "Switch demo" } };
  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{translation.settings.settings}</h1>
        </div>
        <Card className="cards">
          <form>
            <CardContent sx={{ p: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={6}
                  xs={12}
                  sx={{ paddingBottom: "10px" }}
                >
                  <Typography className="sub_headings">
                    {translation.settings.manage_fee}
                  </Typography>
                  <Typography
                    className="custom_label"
                    sx={{ paddingTop: "10px" }}
                  >
                    {translation.settings.transaction_fee}
                  </Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="transactionFee"
                    variant="outlined"
                    fullWidth
                    placeholder={translation.settings.transaction_fee}
                  />
                </Grid>
                <Grid item xs={4} />
                <Grid item xs={4} />
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={6}
                  xs={12}
                  sx={{ paddingBottom: "10px" }}
                >
                  <Typography className="sub_headings">
                    {translation.settings.manage_savings}
                  </Typography>
                  <Typography
                    className="custom_label"
                    sx={{ paddingTop: "10px" }}
                  >
                    {translation.settings.date}
                  </Typography>
                  <TextField
                    className="text_field"
                    hiddenLabel
                    placeholder={translation.settings.date}
                    fullWidth
                    name="dateOfTransfer"
                    variant="outlined"
                    type={"date"}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className="sub_headings">
                    {translation.settings.enable_disable}
                  </Typography>
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                  sx={{ paddingTop: "10px" }}
                >
                  <Box className="switch_flex">
                    <Typography className="custom_label">{translation.settings.ACHQ}</Typography>
                    <Switch {...label} defaultChecked size="small" />
                  </Box>
                </Grid>

                <Grid
                  item
                  lg={3}
                  md={3}
                  sm={6}
                  xs={6}
                  sx={{ paddingTop: "10px" }}
                >
                  <Box className="switch_flex">
                    <Typography className="custom_label">{translation.settings.plaid}</Typography>
                    <Switch {...label} defaultChecked size="small" />
                  </Box>
                </Grid>
              </Grid>
              <div className="form_btn">
                <Button size="large" type="submit" className="btn btn_primary">
                  {translation.settings.save}
                </Button>
              </div>
            </CardContent>
          </form>
        </Card>
      </div>
    </MainContainer>
  );
};

export default Settings;
